import { createPhotoBoothAPI } from '@photobooth/api-client';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000';

export const api = createPhotoBoothAPI({
  baseUrl: API_URL,
});

// Set auth token from localStorage on initialization
const token = localStorage.getItem('auth_token');
if (token) {
  api.setAuthToken(token);
}

// Update token when it changes
export function updateAuthToken(token: string | null) {
  api.setAuthToken(token);
  if (token) {
    localStorage.setItem('auth_token', token);
  } else {
    localStorage.removeItem('auth_token');
  }
}
